import api from 'service/api'

const dponetAPI = api.create('dponet')

const index = async ({ courseId, ...params }) => {
  return dponetAPI.get(`/training_courses/${courseId}/training_enrollments`, {
    params,
  })
}

const create = async ({ courseId, ...data }) => {
  return dponetAPI.post(
    `/training_courses/${courseId}/training_enrollments`,
    data,
  )
}

const update = async ({ courseId, enrollmentId, ...data }) => {
  return dponetAPI.put(
    `/training_courses/${courseId}/training_enrollments/${enrollmentId}`,
    data,
  )
}

const destroy = async ({ courseId, enrollmentId }) => {
  return dponetAPI.delete(
    `/training_courses/${courseId}/training_enrollments/${enrollmentId}`,
  )
}

const changeStatus = async ({ courseId, enrollmentId }) => {
  return dponetAPI.patch(
    `/training_courses/${courseId}/training_enrollments/${enrollmentId}/change_status`,
  )
}

const notify = async ({ courseId, enrollmentId, ...data }) => {
  return dponetAPI.post(
    `/training_courses/${courseId}/training_enrollments/${enrollmentId}/notify`,
    data,
  )
}

const batchNotify = async ({ courseId, enrollmentIds, message }) => {
  return Promise.all(
    enrollmentIds.map((enrollmentId) =>
      notify({ courseId, enrollmentId, message }),
    ),
  )
}

const importStudents = async ({ courseId, file }) => {
  const formData = new FormData()
  formData.append('file', file)
  return dponetAPI.post(
    `/training_courses/${courseId}/training_enrollments/import`,
    formData,
  )
}

const enrollByGroup = async ({
  courseId,
  departmentIds,
  profileIds,
  userIds,
}) =>
  dponetAPI.post(
    `/training_courses/${courseId}/training_enrollments/enroll_by_group`,
    {
      department_ids: departmentIds,
      profile_ids: profileIds,
      user_ids: userIds,
    },
  )

const companyUsers = async ({ ...params }) => {
  return dponetAPI.get('/training_company_users', { params })
}

const trainingEnrollment = {
  index,
  create,
  update,
  destroy,
  changeStatus,
  notify,
  batchNotify,
  importStudents,
  enrollByGroup,
  companyUsers,
}

export default trainingEnrollment
